<template>
  <!-- Start Features Area -->
  <section class="features-area ptb-80 bg-f7fafd">
    <div class="container">
      <div class="section-title">
        <h2>Naše služby</h2>
        <div class="bar"></div>
        <!--                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>-->
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="single-features">
            <div class="icon">
              <feather type="layout"></feather>
            </div>

            <h3>Webové portály</h3>
            <p>Využíváme moderní technologie a správně navrženou architekturu, abychom vytvořili bezpečný portál s intuitivním rozhraním. Naše řešení se zaměřuje na optimalizaci uživatelského zážitku a zlepšení interakce s obsahem.</p>
          </div>
        </div>


        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="single-features">
            <div class="icon">
              <feather type="shopping-cart"></feather>
            </div>

            <h3>E-comerce řešení</h3>
            <p>Snažíme se poskytnout nejlepší řešení pro naše klienty v oblasti vývoje internetových obchodů. Spolupracujeme s nimi na individuálním přístupu v tvorbě obchodu, který odpovídá jejich specifickým potřebám. </p>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="single-features">
            <div class="icon bg-c679e3">
              <feather type="globe"></feather>
            </div>

            <h3>Webové stránky</h3>
            <p>Webové stránky jsou vizitkou každého podniku v online světě a jsou důležité pro to, aby se podnik dostal k potenciálním zákazníkům. Proto se snažíme vytvářet moderní a profesionální webové stránky.</p>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="single-features">
            <div class="icon bg-eb6b3d">
              <feather type="help-circle"></feather>
            </div>

            <h3>Individální aplikace</h3>
            <p>Pro konkrétní požadavky, naše firma vám nabízí vývoj individuální aplikace na míru. Vývoj moderních aplikací využívajících nejnovější technologie a přístupy, abychom zajistili, že naše řešení bude efektivní a funkční.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Features Area -->
</template>

<script>
export default {
  name: 'Features'
}
</script>
